import { Middleware, MiddlewareAPI } from 'redux';
import { REHYDRATE } from 'redux-persist/lib/constants';

import { AppState } from '../../../libs/IdeLink.Web.Common/src/app/AppState';
import { UserActions } from '../../../libs/IdeLink.Web.Common/src/modules/User/UserActions';
import { AppActions } from '../../../libs/IdeLink.Web.Common/src/redux/AppActions';
import { PermissionsActions } from './PermissionsActions';

export const PermissionsMiddleware: Middleware = ({ dispatch, getState }: MiddlewareAPI<any, AppState>) => next => action => {
    // ! exist in ThunkMiddleware
    // if (typeof action === 'function') {
    //     return action(dispatch, getState);
    // }
    if (action && action.type === AppActions.APP_ESSENTIAL_RELOAD) {
        dispatch(PermissionsActions.setInitialized(false));
    }
    if (action && action.type === UserActions.SET_AUTHENTICATED_USER_INFO) {
        dispatch(PermissionsActions.initPerms(action.info.administrator_permissions));
    }
    if (action && action.type === REHYDRATE && action.payload) {
        const res = next(action);

        const appState = action.payload as AppState;

        //* Authentication and User exist because they are persisted
        const isAuth = appState.Authentication && appState.Authentication.get('isAuthenticated');
        const info = appState.User && appState.User.get('info');
        if (isAuth && info) {
            dispatch(PermissionsActions.initPerms(info.administrator_permissions));
        }
        return res;
    }
    return next(action);
};

